export const videoCategories = [
  { slug: 'movie', name: '电影大全', icon: 'ri-movie-2-line', description: '最新最全的电影资源，动作片、喜剧片、爱情片应有尽有' },
  { slug: 'tv-series', name: '电视剧全集', icon: 'ri-tv-2-line', description: '热门电视剧全集免费在线观看，持续更新中' },
  { slug: 'variety', name: '综艺娱乐', icon: 'ri-emotion-laugh-line', description: '搞笑综艺、真人秀、选秀节目精彩纷呈' },
  { slug: 'anime', name: '动漫动画', icon: 'ri-rocket-line', description: '国内外热门动漫，日漫国漫一网打尽' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', description: '自然探索、历史人文、科技解密精品纪录片' },
  { slug: 'short-video', name: '短视频', icon: 'ri-smartphone-line', description: '精彩短视频，搞笑、生活、创意无限' },
];

export const featuredVideos = [
  {
    id: 1,
    title: '流浪地球3：星际远征',
    category: 'movie',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=a%20cinematic%20sci-fi%20movie%20poster%20with%20astronauts%20and%20a%20giant%20spaceship%20against%20a%20starfield%20backdrop%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20tones%2C%20epic%20scale%2C%20clean%20composition%20with%20simple%20dark%20background&width=640&height=360&seq=douhua-video-01&orientation=landscape',
    duration: '02:18:45',
    views: '1280万',
    rating: 9.2,
    description: '人类文明面临前所未有的挑战，一支精英小队踏上了跨越星际的远征之旅。',
  },
  {
    id: 2,
    title: '繁花似锦：都市风华录',
    category: 'tv-series',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=a%20modern%20chinese%20urban%20drama%20series%20poster%20with%20fashionable%20characters%20walking%20through%20a%20bustling%20city%20street%20at%20night%2C%20warm%20golden%20neon%20lights%2C%20elegant%20composition%2C%20cinematic%20style%20with%20soft%20bokeh%20background&width=640&height=360&seq=douhua-video-02&orientation=landscape',
    duration: '共40集',
    views: '3560万',
    rating: 9.5,
    description: '讲述都市中一群年轻人追逐梦想、收获爱情与成长的温暖故事。',
  },
  {
    id: 3,
    title: '荒野求生：亚马逊秘境',
    category: 'documentary',
    categoryName: '纪录片',
    image: 'https://readdy.ai/api/search-image?query=a%20nature%20documentary%20poster%20showing%20dense%20amazon%20rainforest%20with%20sunlight%20streaming%20through%20canopy%2C%20exotic%20wildlife%2C%20misty%20morning%20atmosphere%2C%20warm%20green%20and%20gold%20tones%2C%20cinematic%20photography%20style&width=640&height=360&seq=douhua-video-03&orientation=landscape',
    duration: '01:35:20',
    views: '890万',
    rating: 9.7,
    description: '深入亚马逊雨林腹地，探秘地球上最神秘的自然王国。',
  },
  {
    id: 4,
    title: '乘风破浪的姐姐 第五季',
    category: 'variety',
    categoryName: '综艺',
    image: 'https://readdy.ai/api/search-image?query=a%20chinese%20variety%20show%20poster%20with%20elegant%20female%20performers%20on%20a%20grand%20stage%20with%20dramatic%20spotlights%2C%20warm%20golden%20and%20coral%20lighting%2C%20glamorous%20atmosphere%2C%20clean%20composition&width=640&height=360&seq=douhua-video-04&orientation=landscape',
    duration: '共12期',
    views: '5200万',
    rating: 9.3,
    description: '三十位姐姐重返舞台，用实力证明年龄只是数字，精彩绝伦的舞台对决。',
  },
  {
    id: 5,
    title: '鬼灭之刃：无限城篇',
    category: 'anime',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=a%20japanese%20anime%20movie%20poster%20with%20warrior%20characters%20wielding%20swords%20in%20a%20mystical%20setting%2C%20dramatic%20warm%20red%20and%20orange%20color%20palette%2C%20dynamic%20composition%2C%20dark%20background%20with%20flame%20effects&width=640&height=360&seq=douhua-video-05&orientation=landscape',
    duration: '02:05:30',
    views: '2100万',
    rating: 9.6,
    description: '炭治郎与伙伴们深入无限城，与上弦之鬼展开最终决战。',
  },
  {
    id: 6,
    title: '长安十二时辰之天火',
    category: 'movie',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=a%20historical%20chinese%20action%20movie%20poster%20set%20in%20ancient%20Tang%20dynasty%20city%20at%20night%2C%20lanterns%20and%20fire%2C%20warriors%20in%20traditional%20armor%2C%20dramatic%20warm%20amber%20lighting%2C%20cinematic%20epic%20style&width=640&height=360&seq=douhua-video-06&orientation=landscape',
    duration: '02:25:10',
    views: '1960万',
    rating: 8.9,
    description: '大唐盛世之下暗流涌动，一名死囚如何在十二时辰内拯救长安城？',
  },
  {
    id: 7,
    title: '爆笑喜剧人 第8季',
    category: 'variety',
    categoryName: '综艺',
    image: 'https://readdy.ai/api/search-image?query=a%20chinese%20comedy%20variety%20show%20poster%20with%20comedians%20on%20a%20colorful%20stage%2C%20bright%20warm%20lighting%2C%20playful%20atmosphere%2C%20clean%20composition%20with%20simple%20background&width=640&height=360&seq=douhua-video-07&orientation=landscape',
    duration: '共10期',
    views: '4300万',
    rating: 9.1,
    description: '全国最搞笑的喜剧人齐聚一堂，爆笑不断，欢乐不停。',
  },
  {
    id: 8,
    title: '进击的巨人 最终季 后篇',
    category: 'anime',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=an%20epic%20anime%20poster%20with%20titan%20creatures%20and%20soldiers%20in%20a%20dramatic%20battle%20scene%2C%20warm%20sunset%20orange%20sky%2C%20cinematic%20composition%2C%20dark%20silhouettes%20against%20golden%20light&width=640&height=360&seq=douhua-video-08&orientation=landscape',
    duration: '01:28:00',
    views: '3400万',
    rating: 9.8,
    description: '艾伦发动地鸣，帕拉迪岛的命运悬于一线，一切将走向终结。',
  },
];

export const trendingList = [
  { id: 1, title: '繁花似锦：都市风华录', rank: 1, category: '电视剧', hot: '🔥 热播' },
  { id: 2, title: '乘风破浪的姐姐 第五季', rank: 2, category: '综艺', hot: '🔥 热播' },
  { id: 3, title: '流浪地球3：星际远征', rank: 3, category: '电影', hot: '🔥 新上映' },
  { id: 4, title: '进击的巨人 最终季 后篇', rank: 4, category: '动漫', hot: '🔥 热搜' },
  { id: 5, title: '长安十二时辰之天火', rank: 5, category: '电影', hot: '🔥 热播' },
  { id: 6, title: '荒野求生：亚马逊秘境', rank: 6, category: '纪录片', hot: '⭐ 推荐' },
  { id: 7, title: '鬼灭之刃：无限城篇', rank: 7, category: '动漫', hot: '⭐ 推荐' },
  { id: 8, title: '爆笑喜剧人 第8季', rank: 8, category: '综艺', hot: '⭐ 推荐' },
  { id: 9, title: '大明风华录', rank: 9, category: '电视剧', hot: '📈 上升' },
  { id: 10, title: '舌尖上的中国 第五季', rank: 10, category: '纪录片', hot: '📈 上升' },
];

export const articles = [
  {
    id: 1,
    title: '2026年最值得期待的十大国产电影，每一部都是视觉盛宴',
    excerpt: '从科幻巨制到古装史诗，2026年的国产电影市场精彩纷呈。我们为你盘点了最值得期待的十部作品...',
    image: 'https://readdy.ai/api/search-image?query=a%20cinema%20interior%20with%20movie%20posters%20on%20the%20wall%2C%20warm%20golden%20lighting%2C%20elegant%20atmosphere%2C%20cinematic%20style%20photography%2C%20clean%20composition&width=800&height=450&seq=douhua-article-01&orientation=landscape',
    category: '影视资讯',
    author: '豆花编辑部',
    date: '2026-07-28',
    readTime: '8分钟',
    content: '2026年，国产电影市场迎来了前所未有的繁荣。从科幻大片到文艺佳作，从古装史诗到现实题材，各类影片百花齐放。以下是豆花视频为你精心挑选的十部最值得期待的国产电影。每一部都将在豆花视频平台上线，免费高清观看。\n\n排在首位的是《流浪地球3：星际远征》，这部科幻巨制延续了前两部的宏大世界观，将带领观众踏上跨越星际的壮丽征程。其次，《长安十二时辰之天火》以盛唐为背景，融合了悬疑与动作元素，视觉效果令人惊叹。\n\n第三部值得关注的是《深海回响》，这部动画电影讲述了一段关于海洋与勇气的奇幻冒险，画面精美绝伦。此外还有多部现实主义题材作品，用镜头记录时代变迁中普通人的故事。\n\n在古装题材方面，《大明风华录》以明朝为背景，讲述了宫廷内外的爱恨情仇；《剑雨浮生》则是一部武侠片，动作场面设计精妙。\n\n对于喜爱文艺片的观众，《南方车站的冬天》和《山间的风》都是不可错过的佳作。这些影片在国际电影节上获得了广泛好评。\n\n最后，《美食家之路》和《极限巅峰》作为纪录片，分别探索了中华美食文化和极限运动的魅力。这些影片都将在豆花视频免费播出，敬请期待！',
  },
  {
    id: 2,
    title: '豆花视频独家：热门综艺《乘风破浪的姐姐》幕后花絮大揭秘',
    excerpt: '《乘风破浪的姐姐》第五季正在热播，豆花视频带你走进节目幕后，看看姐姐们的真实状态...',
    image: 'https://readdy.ai/api/search-image?query=a%20backstage%20TV%20studio%20with%20makeup%20mirrors%20and%20costumes%2C%20warm%20soft%20lighting%2C%20elegant%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20documentary%20style&width=800&height=450&seq=douhua-article-02&orientation=landscape',
    category: '综艺八卦',
    author: '豆花编辑部',
    date: '2026-07-25',
    readTime: '6分钟',
    content: '《乘风破浪的姐姐》第五季自开播以来，热度持续攀升。作为豆花视频平台的热门内容，我们特地深入节目录制现场，为大家带来独家幕后花絮。\n\n在录制现场，我们看到姐姐们每天凌晨就开始化妆准备，一遍遍地排练舞蹈，即使在休息时间也在互相交流动作要领。这种敬业精神令人敬佩。\n\n节目组的导演透露，本季最大的挑战是如何在保持节目品质的同时，给观众带来新鲜感。为此，他们邀请了国际顶级的舞美团队，打造了全新的舞台效果。\n\n姐姐们在镜头前光鲜亮丽，但背后付出了常人难以想象的努力。有的姐姐为了一个动作练习到凌晨三点，有的姐姐带伤坚持排练。正是这种拼搏精神，让这个节目充满了感染力。\n\n豆花视频将持续关注本季节目的最新动态，为观众带来更多精彩内容。记得在豆花视频免费观看《乘风破浪的姐姐》第五季全集，高清不缓冲！',
  },
  {
    id: 3,
    title: '动漫迷必看！2026年夏季新番推荐指南',
    excerpt: '夏季新番陆续开播，豆花视频为你整理了最值得追的十部动漫新作，涵盖热血、治愈、悬疑等多种类型...',
    image: 'https://readdy.ai/api/search-image?query=a%20collection%20of%20anime%20artwork%20displayed%20on%20a%20wall%2C%20colorful%20illustrations%2C%20warm%20ambient%20lighting%2C%20otaku%20room%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=douhua-article-03&orientation=landscape',
    category: '动漫推荐',
    author: '豆花编辑部',
    date: '2026-07-20',
    readTime: '7分钟',
    content: '夏日炎炎，最适合窝在家里追番了！豆花视频为大家整理了2026年夏季最值得追的十部新番动漫，让你这个夏天不再无聊。\n\n热血战斗类：《鬼灭之刃：无限城篇》无疑是本季最受关注的作品，炭治郎与上弦之鬼的最终决战即将展开。《咒术回战》新篇章同样精彩，五条悟的过去将被揭开。\n\n治愈日常类：《小森林的四季》以细腻的笔触描绘了乡村生活的美好，画面温暖治愈。《与猫相伴的日子》讲述了独居女孩与流浪猫的温馨故事。\n\n悬疑推理类：《暗夜追踪者》以都市传说为背景，剧情紧凑，悬念迭起。《时间旅者的日记》则是一部关于时空穿越的烧脑之作。\n\n此外，《星际旅人》、《机甲战纪》、《魔法学院的日常》和《深海之歌》也各具特色，涵盖了科幻、机甲、魔法和奇幻等多种题材。\n\n以上所有动漫作品都可以在豆花视频免费在线观看，高清不缓冲，快来开启你的夏日追番之旅吧！',
  },
  {
    id: 4,
    title: '豆花视频使用指南：如何获得最佳观影体验',
    excerpt: '想让观影体验更上一层楼？豆花视频为你准备了详细的使用指南，从网络设置到设备推荐一应俱全...',
    image: 'https://readdy.ai/api/search-image?query=a%20cozy%20home%20theater%20setup%20with%20a%20large%20TV%20screen%20displaying%20a%20movie%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%2C%20modern%20interior%20design&width=800&height=450&seq=douhua-article-04&orientation=landscape',
    category: '使用指南',
    author: '豆花编辑部',
    date: '2026-07-18',
    readTime: '5分钟',
    content: '在豆花视频观看影视内容，如何才能获得最佳的观影体验？这篇指南将为你详细解答。\n\n首先，网络环境是关键。建议使用至少10Mbps以上的宽带网络，Wi-Fi信号要稳定。如果使用移动网络观看，建议在4G/5G信号良好的环境下使用。豆花视频采用了先进的视频压缩和CDN加速技术，确保高清不缓冲的流畅体验。\n\n其次，设备选择也很重要。对于大屏观影，推荐使用智能电视或投影仪连接电脑/手机投屏。豆花视频支持多种投屏协议，一键即可将内容投射到大屏幕上。对于移动端用户，建议使用屏幕尺寸在6英寸以上的设备，以获得更好的视觉体验。\n\n第三，观影环境。调暗室内灯光，选择一个舒适的观影位置，准备一些零食饮品，就能打造专属的家庭影院体验。\n\n最后，豆花视频的所有内容都是免费在线观看的。你可以在西瓜视频、芒果视频、丝瓜视频等多个资源站之间自由切换，选择最适合你的内容来源。',
  },
  {
    id: 5,
    title: '纪录片爱好者福利：五部改变人生观的经典纪录片',
    excerpt: '纪录片不仅是知识的载体，更是一扇通往未知世界的窗口。豆花视频精选五部必看纪录片推荐给你...',
    image: 'https://readdy.ai/api/search-image?query=a%20documentary%20film%20screening%20room%20with%20a%20large%20projection%20screen%20showing%20nature%20scenes%2C%20warm%20dim%20lighting%2C%20cinema%20atmosphere%2C%20intellectual%20vibe&width=800&height=450&seq=douhua-article-05&orientation=landscape',
    category: '纪录片推荐',
    author: '豆花编辑部',
    date: '2026-07-15',
    readTime: '6分钟',
    content: '一部好的纪录片可以改变你看世界的方式。豆花视频为大家精选了五部不可错过的经典纪录片，每一部都值得反复观看。\n\n第一部：《地球脉动》系列——这部BBC出品的自然纪录片以惊人的画质展示了地球上最壮丽的自然景观和最神奇的生物。从极地冰原到热带雨林，每一帧都是壁纸级别的画面。\n\n第二部：《人间世》——这部中国纪录片真实记录了医院里的人间百态，生离死别、医患关系、人性光辉，每一个故事都令人动容。\n\n第三部：《舌尖上的中国》——这不仅仅是一部美食纪录片，更是对中国饮食文化和人文情怀的深度探索。\n\n第四部：《我在故宫修文物》——展现了文物修复师们的匠心精神，让我们看到那些沉默在博物馆里的文物背后的故事。\n\n第五部：《蓝色星球》——深入海洋世界，探索地球上最后的未知领域，画面震撼人心。\n\n以上所有纪录片都可以在豆花视频免费在线观看，现在就开启你的纪录片之旅吧！',
  },
];

export const faqData = [
  {
    question: '豆花视频真的免费吗？需要注册吗？',
    answer: '豆花视频完全免费在线观看，无需注册和登录。我们汇集了西瓜视频、芒果视频、丝瓜视频等优质免费影视资源，打开即可观看，高清流畅不缓冲。',
  },
  {
    question: '豆花视频支持哪些设备观看？',
    answer: '豆花视频支持电脑、平板、手机等多种设备观看。网站采用响应式设计，自动适配不同屏幕尺寸。同时支持投屏功能，可以将内容投射到智能电视上享受大屏观影体验。',
  },
  {
    question: '视频画质如何？会不会卡顿？',
    answer: '豆花视频提供高清画质内容，采用先进的CDN加速技术和视频压缩算法，确保播放流畅不卡顿。即使在网络条件一般的情况下，也能获得良好的观看体验。',
  },
  {
    question: '豆花视频有哪些内容分类？',
    answer: '豆花视频涵盖电影大全、电视剧全集、综艺娱乐、动漫动画、纪录片、短视频等丰富分类。无论你喜欢什么类型的影视内容，都能在这里找到心仪的作品。',
  },
  {
    question: '如何搜索我想看的影片？',
    answer: '你可以通过首页的搜索框输入关键词查找影片，也可以按分类浏览。网站会根据你的浏览偏好推荐相关内容，帮助你更快找到感兴趣的影视作品。',
  },
  {
    question: '豆花视频的资源更新速度快吗？',
    answer: '豆花视频致力于为用户提供最新的影视资源。热门电影、电视剧、综艺节目会在第一时间更新上线，确保你不会错过任何精彩内容。',
  },
  {
    question: '豆花视频与西瓜视频、芒果视频是什么关系？',
    answer: '豆花视频是一个影视资源导航平台，我们收录了西瓜视频、芒果视频、丝瓜视频等多个平台的免费影视资源。用户可以在豆花视频一站式浏览和观看来自不同平台的内容。',
  },
];

export const brandInfo = {
  name: '豆花视频',
  slogan: '免费在线观看，高清不缓冲',
  founded: '2024年',
  intro: '豆花视频是一家专注于免费在线影视内容导航的互联网平台。自2024年成立以来，我们始终致力于为广大用户提供最便捷、最高清、最流畅的观影体验。平台汇集了西瓜视频免费、芒果视频、丝瓜视频等多个平台的优质影视资源，涵盖电影大全、电视剧全集、综艺娱乐、动漫动画、纪录片等丰富内容。',
  mission: '让每个人都能轻松享受高质量的影视内容',
  vision: '成为中文互联网最受欢迎的免费影视导航平台',
  values: ['用户至上', '内容为王', '技术驱动', '开放共赢'],
  milestones: [
    { year: '2024年3月', event: '豆花视频平台正式上线' },
    { year: '2024年6月', event: '日活跃用户突破100万' },
    { year: '2024年9月', event: '接入芒果视频资源，内容库翻倍' },
    { year: '2024年12月', event: '上线分类导航和智能推荐功能' },
    { year: '2025年3月', event: '日活跃用户突破500万' },
    { year: '2025年6月', event: '完成技术架构升级，播放流畅度提升50%' },
    { year: '2025年9月', event: '接入西瓜视频资源，内容覆盖更全面' },
    { year: '2025年12月', event: '荣获年度最佳免费影视平台称号' },
    { year: '2026年3月', event: '全球月活跃用户突破3000万' },
    { year: '2026年7月', event: '平台内容总量突破10万部' },
  ],
  stats: [
    { label: '月活跃用户', value: '3000万+' },
    { label: '影视资源', value: '10万+' },
    { label: '日均播放', value: '5000万+' },
    { label: '用户好评率', value: '98.6%' },
  ],
  contact: {
    email: 'contact@douhua.example.com',
    wechat: '豆花视频官方',
    weibo: '@豆花视频',
    address: '中国北京市朝阳区互联网产业园',
  },
};

export const testimonials = [
  {
    name: '王先生',
    avatar: 'https://readdy.ai/api/search-image?query=a%20professional%20portrait%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20friendly%20expression&width=80&height=80&seq=douhua-testimonial-01&orientation=squarish',
    role: '资深影迷',
    content: '豆花视频真的太好用了！资源丰富，高清不卡顿，而且完全免费。现在每天晚上都会在上面找电影看，太方便了。',
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=a%20professional%20portrait%20of%20a%20Chinese%20woman%20in%20her%2020s%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20friendly%20smile&width=80&height=80&seq=douhua-testimonial-02&orientation=squarish',
    role: '追剧达人',
    content: '作为一个重度追剧患者，豆花视频简直就是我的救星！电视剧更新速度快，画质清晰，而且免费，强烈推荐！',
  },
  {
    name: '张同学',
    avatar: 'https://readdy.ai/api/search-image?query=a%20professional%20portrait%20of%20a%20young%20Chinese%20man%20student%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20casual%20friendly%20expression&width=80&height=80&seq=douhua-testimonial-03&orientation=squarish',
    role: '大学生',
    content: '学生党预算有限，豆花视频免费看真的很良心。动漫资源超全，周末和室友一起追番是最快乐的事！',
  },
];